import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface DangerConfirmData {
  title: string;
  /** Lines shown in the warning body, rendered in order. */
  warnings: string[];
  /** The exact text the admin must retype to unlock the confirm button. */
  confirmText: string;
  /** Label describing what confirmText is (e.g. "username"). */
  confirmLabel: string;
}

/**
 * A deliberately hard-to-misclick confirmation for irreversible, cascading
 * deletes. Unlike ConfirmDialog, this requires the admin to retype an exact
 * value (not just click a button) before the destructive action unlocks.
 */
@Component({
  selector: 'app-danger-confirm-dialog',
  imports: [FormsModule, MatDialogModule, MatButtonModule, MatIconModule, MatFormFieldModule, MatInputModule],
  templateUrl: './danger-confirm-dialog.html',
  styleUrl: './danger-confirm-dialog.scss'
})
export class DangerConfirmDialog {
  readonly dialogRef = inject(MatDialogRef<DangerConfirmDialog>);
  readonly data = inject<DangerConfirmData>(MAT_DIALOG_DATA);

  typedValue = '';

  get isUnlocked(): boolean {
    return this.typedValue === this.data.confirmText;
  }

  confirm(): void {
    if (this.isUnlocked) {
      this.dialogRef.close(true);
    }
  }
}
